<template lang="pug">
  div
    filter-table(
      layout="text"
      @inputSearchFilter="inputSearchFilter")
    .credits-table.ods-mt-6
      ods-table(
        v-loading="loadingTable"
        style='width: 100%'
        :data='tableDataRendered'
        :default-sort = "{prop: 'tariff', order: 'descending'}"
        @expand-change="showTramos",
        :row-key="getRowKey"
        :expand-row-keys="expandKey"
        )
        ods-table-column(prop='destipc' label='Tipo de producto' sortable)
        ods-table-column(prop='desconeco' label='Tarifa' sortable)
        ods-table-column(prop='impfijo' label='Importe Fijo' sortable)
          template(slot-scope="scope")
            div {{ scope.row.impfijo | toCurrencyCode(scope.row.clamon) }}
        ods-table-column(prop='impmin' label='Importe Mínimo' sortable)
          template(slot-scope="scope")
            div {{ scope.row.impmin | toCurrencyCode(scope.row.clamon) }}
        ods-table-column(prop='impmax' label='Importe Máximo' sortable)
          template(slot-scope="scope")
            div {{ scope.row.impmax | toCurrencyCode(scope.row.clamon) }}
        ods-table-column(type="expand")
          template(slot-scope="props")
            .tramos
              p.title.tp-m-micro Tramos de Tarifa
              ods-table(
                v-if="Array.isArray(tramos) && tramos.length"
                style='width: 100%'
                :data='tramos'
                stripe
                @expand-change="showTramos2",
                :row-key="getRowKey"
                :expand-row-keys="expandKey2"
                )
                ods-table-column(prop='trfincon' label='Tramos (hasta)')
                  template(slot-scope="scope")
                    div {{ scope.row.trfincon | toCurrencyCode(scope.row.clamon) }}
                ods-table-column(prop='portramoconc' :label="tramosLabel")
                  template(slot-scope="scope")
                    div {{ scope.row.portramoconc }}{{ percentageSymbol }}
                ods-table-column(type="expand")
                  template(slot-scope="props")
                    ods-table(
                      v-if="Array.isArray(tramos2) && tramos2.length"
                      style='width: 95%'
                      :data='tramos2'
                      stripe
                      class="second-table"
                      )
                      ods-table-column(prop='trfincoe' label='Tramos (hasta)')
                        template(slot-scope="scope")
                          div {{ scope.row.trfincoe | toCurrencyCode(scope.row.clamon) }}
                      ods-table-column(prop='portramocoef' label='Coeficiente')
                        template(slot-scope="scope")
                          div {{ scope.row.portramocoef }}

                    p.notfound(v-else) No se han encontrado tramos por meses asociados a esta tarifa

              p.notfound(v-else)
                template(v-if="loadingAxios") {{ $t('tabTariff.loadingSections') }}
                template(v-else) {{ $t('tabTariff.notFoundSections') }}

      div.footer
        paginator(
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage")
        //- ods-pagination.footer__page(
        //- :page-sizes = '[5, 10, 50, 100]',
        //- :page-size = itemsPerPage,
        //- layout='prev, pager, next',
        //- :total='totalData'
        //- @size-change='handleSizeChange',
        //- @current-change='handleCurrentChange'
        //- style="text-align: right; margin-top: 20px")

</template>

<script>
import { mapGetters } from 'vuex'
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'

export default {
  name: 'ProducttypeTable',

  components: {
    FilterTable,
    Paginator
  },

  props: {
    // data: {
    //   required: true
    // },

    commerce: {
      required: true
    }
  },

  data () {
    return {
      defaultParams: {
        producto: this.$route.params.comercio.producto,
        subproducto: this.$route.params.comercio.subproducto,
        conprod: this.$route.params.comercio.conprod.toString(),
        codcom: this.$route.params.comercio.codcom
      },
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false,
      expandKey: [],
      expandKey2: [],
      // tableData: this.data,
      // itemsPerPage: 10,
      // currentPageData: 1,
      // totalData: 0,
      tramos: [],
      tramos2: [],
      tramosLabel: 'Porcentaje',
      percentageSymbol: '%',
      firstdata: {}
    }
  },

  computed: {
    ...mapGetters([
      'loadingAxios'
    ])
  },

  // watch: {
  //   data (newData, oldData) {
  //     this.tableData = newData
  //     this.totalData = newData.length
  //   }
  // },

  methods: {
    async getData (params) {
      this.loadingTable = true
      // Listado de Tarifario - Tipos de Financiación
      await this.$store.dispatch('getLoansTariff', params)
        .then((res) => {
          this.loadingTable = false
          if (res.registros) {
            this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
            this.tableDataRendered = this.tableData
          } else {
            this.tableData = null
            this.tableDataRendered = this.tableData
          }
          this.currentPage = res.pantPagina
          this.indMasDatos = res.indMasDatos
          this.paginationParams = {
            claveInicio: res.claveInicio,
            claveFin: res.claveFin
          }
        })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    inputSearchFilter (text) {
      this.tableDataRendered = this.tableData.filter((res) => {
        return res.codtipc.toLowerCase().includes(text.toLowerCase()) ||
          res.destipc.toLowerCase().includes(text.toLowerCase()) ||
          res.desconeco.toLowerCase().includes(text.toLowerCase()) ||
          res.impfijo.toString().toLowerCase().includes(text.toString().replace(',', '.').toLowerCase()) ||
          res.impmin.toString().toLowerCase().includes(text.toString().replace(',', '.').toLowerCase()) ||
          res.impmax.toString().toLowerCase().includes(text.toString().replace(',', '.').toLowerCase())
      })
    },

    // handleSizeChange (val) {
    //   this.itemsPerPage = val
    //   this.handlePagination()
    // },

    // handleCurrentChange (val) {
    //   this.currentPageData = val
    //   this.handlePagination()
    // },

    // handlePagination (arr) {
    //   if (Array.isArray(this.data)) {
    //     this.tableData = this.data.slice(
    //       (this.currentPageData - 1) * this.itemsPerPage,
    //       this.currentPageData * this.itemsPerPage)
    //   }
    // },

    goToDetail (row) {
      this.$router.push('/credits/' + row.number)
    },

    showTramos (row, other) {
      this.tramos = []
      this.tramos2 = []
      this.expandKey = [row.registro_Numero]
      this.firstdata = {
        clamon_t: row.clamon,
        codconeco: row.codconeco,
        codtipc: row.codtipc,
        conprod: this.commerce.conprod,
        producto: this.commerce.producto,
        subprodu: this.commerce.subproducto,
        codmar: 0,
        indtipt: 0
      }
      this.$store.dispatch('getTramosPrestamos', this.firstdata)
        .then((response) => {
          this.tramos = response
          this.tramosLabel = row.tipoaccesocc === 'I' ? 'Porcentaje' : 'Coeficiente'
          this.percentageSymbol = row.tipoaccesocc === 'I' ? '%' : ''
        })
    },

    showTramos2 (row, other) {
      this.tramos2 = []
      this.expandKey2 = [row.registro_Numero]
      const data = {
        clamon_t: this.firstdata.clamon,
        codconeco: row.codconeco,
        codtipc: this.firstdata.codtipc,
        conprod: this.commerce.conprod,
        producto: this.commerce.producto,
        subprodu: this.commerce.subproducto,
        codmar: 0,
        indtipt: 0
      }
      if (row.tpacceconc !== 'I') {
        data.portramoconc = row.portramoconc
        this.$store.dispatch('getTramosPrestamos2', data)
          .then((res) => {
            this.tramos2 = res
          })
      }
    },

    getRowKey (row) {
      return row.registro_Numero
    }
  },

  mounted () {
    this.getInitialData()
    // if (Array.isArray(this.data)) this.totalData = this.data.length
    // this.handlePagination()
  }
}
</script>

<style lang="scss" scoped>
.notfound {
  margin-top: rem(28)
}

/deep/ .ods-table__row {
  cursor: pointer;
}

/deep/ .ods-table__expanded-cell {
  padding: rem(12) rem(24)!important;
  background: #F9F9FB;
}

/deep/ .ods-table__expanded-cell:hover {
  background-color: #F9F9FB!important;
}

/deep/ .ods-table__expanded-cell:hover td {
  border-bottom: 1px solid #d1d9de;
}

.tramos {
  .title {
    text-transform: uppercase;
  }

  .ods-table {
    background: #fff;
    margin: 12px 0;

    &.second-table {
      margin: 0 rem(24);
    }
  }

  /deep/ .ods-table thead th {
    padding: 0;
  }

  /deep/ .ods-table td, .ods-table th {
    padding: 4px 0;
  }

  /deep/ .ods-table__row--striped > td {
    background: #F0F0F0!important;
  }
}
</style>
